/**
 * 열람 전용(viewer) 제한 안내 다이얼로그 상태.
 *
 * viewer 가 분석·업로드 버튼을 눌렀을 때 버튼을 숨기는 대신 **이유를 설명하고 권한 신청으로 이어주기**
 * 위한 것. 다이얼로그 본체는 `components/util/ViewerRestrictedDialog.vue` 이며 `MainLayout` 에 한 개만
 * 두고, 어느 화면에서든 `requireEdit()` 로 연다.
 *
 * 사용법:
 *   if (!requireEdit('분석 실행')) return;   // viewer 면 다이얼로그를 열고 false
 */
import { reactive } from 'vue';
import { isViewer } from 'src/utils/auth';

export const viewerGuardState = reactive<{ open: boolean; action: string }>({
  open: false,
  action: '',
});

/** viewer 제한 안내를 연다(직접 호출은 라우터 가드 등 특수한 경우에만). */
export function openViewerRestricted(action = ''): void {
  viewerGuardState.action = action;
  viewerGuardState.open = true;
}

export function closeViewerRestricted(): void {
  viewerGuardState.open = false;
}

/**
 * 변경 작업(분석 실행·업로드 등) 진입 전 호출한다.
 * 일반/관리자면 true, viewer 면 안내 다이얼로그를 열고 false.
 */
export function requireEdit(action = ''): boolean {
  if (!isViewer()) return true;
  openViewerRestricted(action);
  return false;
}
